import { makeStyles } from '@mui/styles';
import { lighten, Theme } from '@mui/material';
import { ISize } from 'interfaces/Size';

const useStyles = makeStyles((theme: Theme) => {
  // const marginX = innerWidth - theme.breakpoints.values.lg + 48;
  return {
    root: {
      '& .MuiPaper-root': {
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
    },
    responseList: {
      marginBottom: theme.spacing(1),
      // padding: `0 20px 0 ${marginX / 2}px`,
      display: 'flex',
      flexDirection: 'row',
      columnGap: '15px',
      width: '100%',
      height: 'auto',
      // [theme.breakpoints.down('md')]: {
      //   padding: `0 ${theme.spacing(2)}`,
      // },
    },
    responseContainer: {
      overflowY: 'visible',
      padding: (props: ISize) => `0 ${(props?.width - theme.breakpoints.values.lg + 48) / 2}px`,
      [theme.breakpoints.down('md')]: {
        padding: `0 ${theme.spacing(2)}!important`,
      },
    },
    responseItem: {
      minWidth: '266px',
    },
    responseBadge: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '32px',
      height: '32px',
      borderRadius: '5px',
      backgroundColor: theme.palette.grey[400],
      color: theme.palette.grey[50],
    },
    dismissOfferModal: {
      width: '550px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    dismissEmailTextArea: {
      resize: 'none',
      padding: theme.spacing(3),
      width: '100%',
      lineHeight: theme.spacing(3),
      borderRadius: theme.spacing(1),
      borderColor: '#AEAEAE',
      fontFamily: 'inherit',
      color: theme.palette.text.secondary,
    },
    pagination: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: theme.spacing(2),
    },
    createButton: {
      backgroundColor: theme.palette.common.white,
      borderWidth: 1.5,
      borderColor: lighten(theme.palette.primary.dark, 0.3),
      '&:hover': {
        backgroundColor: lighten(theme.palette.primary.main, 0.7),
      },
      color: theme.palette.text.primary,
    },
    iconButton: {
      borderRadius: 8,
      minWidth: 'unset',
      padding: '0 8px',
    },
    iconContainer: {
      display: 'flex',
      // height: '32px',
      width: 'auto',
      position: 'relative',
      alignItems: 'center',
      marginTop: theme.spacing(1),
      marginRight: theme.spacing(2),
      [theme.breakpoints.down('sm')]: {
        marginRight: theme.spacing(4),
      },
    },
    archive: {
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      padding: `0 ${theme.spacing(1)}`,
      color: theme.palette.grey[900],
      '&:hover': {
        color: theme.palette.primary.main,
      },
      [theme.breakpoints.down('sm')]: {
        padding: 0,
      },
    },
    more: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      justifyContent: 'center',
      padding: 0,
      width: '60px',
      height: 56,
      borderRadius: 5,
      backgroundColor: theme.palette.grey[100],
      '& svg': {
        margin: '8px 0 3px',
      },
      [theme.breakpoints.down('md')]: {
        height: 42,
      },
    },
    titleBox: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      columnGap: '10px',
      marginBottom: 0,
      height: '40px',
      '& hr': {
        flex: 1,
      },
    },
    titleBoxText: {
      whiteSpace: 'nowrap',
      [theme.breakpoints.down('md')]: {
        maxWidth: '250px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    },
    listView: {
      overflowY: 'auto',
      marginTop: '8px',
      maxHeight: '500px',
      width: '100%',
      borderRadius: '5px',
      backgroundColor: theme.palette.background.paper,
    },
    listItem: {
      cursor: 'pointer',
      padding: '0',
      borderBottom: `solid 1px ${theme.palette.grey[200]}`,
    },
    meta: {
      columnGap: theme.spacing(1),
      '& strong': {
        marginLeft: theme.spacing(1),
        color: theme.palette.grey[700],
      },
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },
    leftColumn: {
      flex: '0 1 auto',
      paddingLeft: '16px',
      paddingTop: '12px',
      [theme.breakpoints.down('md')]: {
        flex: '0 1 100%',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
      },
    },
    flexBoxes: {
      display: 'flex',
      justifyContent: 'space-between',
      columnGap: '7px',
      marginBottom: '0',
      marginTop: '4px',
    },
    greyBox: {
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: theme.spacing(1),
      borderRadius: '5px',
      backgroundColor: theme.palette.grey[100],
      '& p': {
        color: theme.palette.grey[800],
      },
    },
    incidentsBadge: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '32px',
      height: '32px',
      borderRadius: '5px',
      backgroundColor: theme.palette.grey[400],
      color: theme.palette.grey[50],
    },
    closeIconContainer: {
      position: 'absolute',
      right: -5,
      top: -5,
      color: '#737373',
      cursor: 'pointer',
    },
    offersModalContent: {
      position: 'relative',
      width: '900px',
      height: '700px',
      [theme.breakpoints.down('md')]: {
        width: '100%',
      },
      overflowY: 'hidden',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    modalTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    modalTitleText: {
      fontWeight: '600',
      fontSize: '24px',
      color: '#01195B',
    },
    contentStackView: {
      backgroundColor: '#fefefe',
      border: '0',
      marginTop: '18px',
      marginRight: '2px',
      borderRadius: '12px',
      paddingTop: '12px',
      paddingLeft: '16px',
      paddingRight: '16px',
      [theme.breakpoints.down('sm')]: {
        paddingLeft: '8px',
        paddingRight: '8px',
        marginRight: 0,
      },
    },
    totalAcceptBox: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid rgba(41,97,253,0.24)',
      borderRadius: '4px',
      padding: '4px 8px 4px 6px',
      height: '24px',
    },
    totalAcceptLabel: {
      fontWeight: 400,
      fontSize: '12px',
      whiteSpace: 'nowrap',
       paddingLeft: '4px',
       paddingRight: '4px',
    },
    totalAcceptText: {
      fontWeight: 600,
      fontSize: '12px',
      color: '#2961fd',
      textAlign: 'right',
    },
    totalRequestBox: {
      display: 'flex',
      alignItems: 'center',
      border: '1px solid #E3E7EA',
      borderRadius: '4px',
      padding: '4px 8px 4px 6px',
      height: '24px',
    },
    totalRequestLabel: {
      fontWeight: 400,
      fontSize: '12px',
      color: '#2D2D2F',
      whiteSpace: 'nowrap',
        paddingRight: '4px',
    },
    totalRequestText: {
      fontWeight: 600,
      fontSize: '12px',
      color: '#01195B',
    },
    totalRequestGrid: {
      padding: '0px 0px 0px 0px',
      [theme.breakpoints.down('lg')]: {
        padding: '0px 0px 0px 0px',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '4px 0px 4px 0px',
      },
    },
    totalAcceptGrid: {
      paddingLeft: '6px',
      padding: '0px 0px 0px 0px',
      [theme.breakpoints.down('lg')]: {
        padding: '0px 0px 0px 6px',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '4px 0px 4px 0px',
      },
    },

    totalAcceptAmbulanceGrid: {
      paddingLeft: '6px',
      padding: '0px 0px 0px 0px',
      [theme.breakpoints.down('lg')]: {
        padding: '0px 0px 0px 6px',
      },
      [theme.breakpoints.down('sm')]: {
        padding: '4px 0px 4px 0px',
        marginLeft: '-8px'
      },
    },
    totalRequestAmbulanceGrid: {
      padding: '0px 0px 0px 0px',
      [theme.breakpoints.up('md')]: {
        padding: '0px 0px 0px 0px',
        marginLeft: '-30px'
      },
      [theme.breakpoints.down('sm')]: {
        padding: '4px 0px 4px 0px',
        marginLeft: '-8px'
      },
    },
    acceptResourcesContent: {
      scrollbarColor: '#888888 transparent',
      marginTop: '14px',
      flex: 1,
      overflowY: 'auto',
      [theme.breakpoints.down('sm')]: {
        '&::-webkit-scrollbar': {
          display: 'none',
        },
        scrollbarColor: 'unset',
      },
    },
  };
});

export default useStyles;
